
import {CourseTrack, School} from "../../../../domain/entities/entities";
import {defineComponent, onBeforeMount, PropType, ref} from "vue";
import store from "../../../../infrastructure/repository/store/store";
import courseTrack from "./CourseTrack.vue";
import {RepositoryException} from "../../../../domain/exceptions/exceptions";
import {dispatchErrorBox} from "../mixins";

const __default__ = defineComponent({
  components: { courseTrack },
  props: {
    school: {
      type: Object as PropType<School>,
      required: true,
    },
    color: {
      type: String,
      default: "#121212",
    },
  },

  setup(props) {
    const courseTracks = ref(Array<CourseTrack>());
    const isAllLoaded = ref(false);
    let onlyOneCourseTrack = ref(true);

    onBeforeMount(async () => {
      await loadCourseTracks(props.school.id, false);
    });

    /** Loads all course tracks of a school.
     * @param schoolID Target school ID.
     * @param loadAll Boolean that tells whether the function is going to load all course tracks or a single one.
     */
    async function loadCourseTracks(schoolID: number, loadAll: boolean) {
      try {
        const hasCourseTracks = courseTracks.value.length;
        if (!hasCourseTracks || loadAll) {
          courseTracks.value = await store.dispatch(
            "categories_module/loadCourseTracksOfSchool",
            schoolID
          );
        }

        /* show or hide the "Ver mais trilhas" button */
        onlyOneCourseTrack.value = courseTracks.value.length == 1;

        if (!loadAll) {
          const array: Array<CourseTrack> = new Array<CourseTrack>();
          array.push(courseTracks.value[0]);
          courseTracks.value = array;
        }

        const allCourseTracks = props.school.courseTracks;
        isAllLoaded.value =
          allCourseTracks.length === courseTracks.value.length;
      } catch (e) {
        if (e instanceof RepositoryException) {
          await dispatchErrorBox(e.message);
        } else {
          console.error(e);
          await dispatchErrorBox("Ocorreu um erro inesperado.");
        }
      }
    }

    return {
      courseTracks,
      isAllLoaded,
      onlyOneCourseTrack,
      loadCourseTracks,
    };
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "4025f134": (_ctx.color)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__